import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AppStore } from "@app/core/store/app.store";
import {
  BaseLoggedComponent,
  TipoPerfilSIGO,
} from "@app/core/store/app.store.model";
import { AlertService, DialogService } from "@siu/shared";
import { AvisoUsuarioComponent } from "src/app/modules/01-home/pages/index/components/aviso-usuario/aviso-usuario.component";
import { GuiaUsuarioComponent } from "src/app/modules/01-home/pages/index/components/guia-usuario/guia-usuario/guia-usuario.component";
import { MensajeDisponibilidadComponent } from "../../mensaje-disponibilidad/mensaje-disponibilidad.component";

@Component({
  selector: "app-index",
  templateUrl: "./index-tupa.component.html",
  styleUrls: ["./index-tupa.component.scss"],
})
export class IndexTupaComponent extends BaseLoggedComponent {
  estadoTramite: boolean = false;
  showTransportista: boolean = false;
  showPersonaNatural: boolean = false;
  showCertificadora: boolean = false;
  showOperaciones: boolean = false;
  menuOptions = this.appStore.state.ui.appMenuDashboard;
  menuOptionsOriginal = this.appStore.state.ui.appMenuDashboard;
  showTD: boolean = false;
  constructor(
    private router: Router,
    appStore: AppStore,
    public dialog: DialogService,
    private alert: AlertService
  ) {
    super(appStore);
  }

  ngOnInit(): void {
    this.appStore.sessionAction.loginCompletar();
    let userSession = this.appStore.sessionAction.getUserSesion();

    if (userSession && userSession.TPerfil) {
      this.showTransportista = userSession.TPerfil.includes(
        TipoPerfilSIGO.Transportista
      );
      this.showPersonaNatural = userSession.TPerfil.includes(
        TipoPerfilSIGO.PersonaNatural
      );
      this.showCertificadora = userSession.TPerfil.includes(
        TipoPerfilSIGO.Certificadora
      );
      this.showOperaciones = userSession.TPerfil.includes(
        TipoPerfilSIGO.EspecialistaOperaciones
      );
    }

    // if(!this.showOperaciones){
    //   console.log('avisolocal: '+localStorage.getItem('avisoAceptado'));
    //   if(localStorage.getItem('avisoAceptado')!='1'){
    //     this.handleVerAviso();
    //   }

    // }
  }

  handleNuevoFormularioTupa = (evento) => {
    this.router.navigate(["/procedimientos-tupa/nuevo-formulario-tupa"]);
  };

  handleGestionSolicitudesTupa = (evento, codfrm) => {
    let formu = codfrm.substr(0, 6);
    if (
      this.showTransportista &&
      (formu == "PVN009" || formu == "PVN010" || formu == "PVN011")
    ) {
      //this.toast.warning("Esta solicitud TUPA solo esta permitida para Personas Naturales");
      this.alert.open(
        "Este procedimiento administrativo TUPA solo esta permitido para Personas Naturales, su usuario es de tipo Persona Jurídica!"
      );
      return;
    } else if (
      this.showPersonaNatural &&
      (formu == "PVN012" || formu == "PVN013" || formu == "PVN014")
    ) {
      this.alert.open(
        "Este procedimiento administrativo TUPA solo esta permitido para Personas Jurídicas, su usuario es de tipo Persona Natural!"
      );
      return;
    }

    if (evento == "_blank") {
      //this.alert.open("")
      // this.alert.open("La solicitud del procedimiento seleccionado se debe realizar por el siguiente enlace: http://autorizacionesespeciales.proviasnac.gob.pe:8080/provias48a60tn/a_login", "", { width: "550px" });
      const dialogRef = this.dialog.openMD(MensajeDisponibilidadComponent);
      dialogRef.componentInstance.tituloModal = codfrm;
    } else {
      if (formu == "PVN002" || formu == "PVN003") {
        this.handleVerAviso();
        this.router.navigate([`${evento}`]);
      } else {
        this.router.navigate([`${evento}`]);
      }
    }
  };

  handleSearch = (event) => {
    const inputElement = document.getElementById("search") as HTMLInputElement;
    this.menuOptions.filter((x) => x.label == inputElement.value);

    this.menuOptions = this.menuOptionsOriginal;
    this.menuOptions = this.menuOptions.filter(
      (x) =>
        x.content.toUpperCase().indexOf(inputElement.value.toUpperCase()) > -1
    );
  };

  handleVerGuia = () => {
    const dialogRef = this.dialog.openLG(GuiaUsuarioComponent);
  };
  handleVerAviso = () => {
    const dialogRef = this.dialog.openLG(AvisoUsuarioComponent);
  };

  handleBandeja = (evento) => {
    this.router.navigate(["/bandeja/bandeja-general"]);
  };

  handleGestionSolicitudesTupaBandeja = (evento, td) => {
    if (td == 1) {
      this.showTD = true;
    } else {
      this.showTD = false;
    }
    this.router.navigate(["/procedimientos-tupa/gestion-tupa"], {
      queryParams: { tb: btoa(td) },
    });
  };

  handleConoceEstadoTramite() {
    this.estadoTramite = true;
  }

  handleReturnConoceEstadoTramite() {
    this.estadoTramite = false;
  }

  handleListadoSoli = (evento) => {
    this.router.navigate(["/permiso-bonificacion/listado-solicitudes-bonif"]);
  };

  handleGestionBandejaFirma = () => {
    this.router.navigate(["/bandeja/bandeja-firma"]);
  };

  handleGestionBandejaNotificacion = () => {
    this.router.navigate(["/bandeja/bandeja-notificacion"]);
  };

  handleGestionBandejaVoucherPago = () => {
    this.router.navigate(["/bandeja/bandeja-voucher-pago"]);
  };

  handleReporteIngresos = () => {
    this.router.navigate(["/reportes/reporte-ingresos"]);
  };

  handleGestionComponenteVehicular = () => {
    this.router.navigate(["/configuracion/componente-vehicular"]);
  };

  handleGestionTablaMaestra = () => {
    this.router.navigate(["/configuracion/tabla-maestra"]);
  };

  handleGestionUsuarioSigo = () => {
    this.router.navigate(["/configuracion/usuario-sigo"]);
  };

  handleGestionBandejaCuentaPago = () => {
    this.router.navigate(["/bandeja/bandeja-cuenta-pago"]);
  };

  handleGestionCargaMasiva = () => {
    this.router.navigate(["/tesoreria/carga-archivo"]);
  };

  handleReporteIngresosCuenta = () => {
    this.router.navigate(["/reportes/reporte-ingresos-cuenta"]);
  };

  handleGestionEmpresaCertificadora = () => {
    this.router.navigate(["/configuracion/empresa-certificadora"]);
  };

}
